import SimpleLightbox from "./../../../../../../node_modules/simplelightbox/dist/simple-lightbox.modules.js";

const initLightbox = () => {
    let lightboxes = document.querySelectorAll('.single-image--wrapper a');
    for ( let lb of lightboxes ) {
        const lightbox = new SimpleLightbox(lb, {widthRatio: 1, heightRatio: 1, maxZoom: 50, captions: false});
    }
}

export { initLightbox };